import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { ResponsivePie } from '@nivo/pie';
import theme from '../../../styles/defaultTheme';

export const CustomHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;

  .form-control_select {
    margin: 0;

    #periodFilter_container-select {
      max-width: 200px;
      justify-content: center;
      float: right;
      border: 0;
      cursor: pointer;

      #periodFilter_select-value {
        padding-right: 8px;
      }

      .MuiIconButton-root {
        svg {
          path {
            stroke: ${(props) => props.theme.blackLink};
          }
        }
      }
    }
  }
`;

export const TitleHeader = styled.h4`
  margin: 0;
  font: ${theme.font.h4};
  white-space: nowrap;
  color: ${(props) => props.theme.black};
  font-family: inherit;
`;

export const TextCenteredMetric = styled.text`
  &.quantity {
    font-size: ${theme.font.size36};
    font-weight: bold;
    fill: ${(props) => props.theme.black};
  }

  &.label {
    font-size: ${theme.font.size16};
    color: ${(props) => props.theme.red};
    fill: ${(props) => props.theme.black};
  }
`;

export const LegendsContainer = styled(Box)`
  .MuiBox-root {
    font-size: ${theme.font.size16};
    white-space: nowrap;
    color: ${(props) => props.theme.greyLink};
    cursor: pointer;

    & {
      + .MuiBox-root {
        margin-top: 16px;
      }

      > div {
        width: 6px;
        height: 30px;
        margin-right: 16px;
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.borderYellow};

      }

      > b {
        margin-right: 8px;
        font-size: ${theme.font.size24};
        color: ${(props) => props.theme.blackLink};
      }
    }
  }
`;

export const CustomResponsivePie = styled(ResponsivePie)`
  :hover{
    background: red !important;
  }
`;
